import {useCallback} from "react";
import {useTranslation} from "react-i18next";
import {Flex, theme, Typography} from "antd";
import {capitalize} from "lodash";
import {useGetHazardTypesQuery} from "../../../../redux/api/hazardTypes";
import {ClimateVariable} from "../../../../types/api/assets";
import HelpTooltip from "../../../common/HelpTooltip";

const iconStyle = {fontSize: '', marginLeft: '0.2rem'}

export function useHazardLabel() {
  const {data: hazardTypes} = useGetHazardTypesQuery()
  return useCallback((hazardCode: string) =>
      capitalize(hazardTypes?.find(hazardType => hazardType.code === hazardCode)?.name || hazardCode),
    [hazardTypes])
}

/*
 * "?" of a climate variable: description from the technical document and the hazards it impacts
 */
export default function ClimateVariableHelp({climateVariable, showTitle = true}: {
  climateVariable: ClimateVariable,
  showTitle?: boolean,
}) {

  const {t} = useTranslation()
  const getHazardLabel = useHazardLabel()
  const {token} = theme.useToken()

  const title = <Flex gap={'0.5rem'} vertical>
    {showTitle && <Typography.Text strong>
      {climateVariable.label}{climateVariable.um ? ` (${climateVariable.um})` : ''}
    </Typography.Text>}
    {climateVariable.description && <Typography.Text>{climateVariable.description}</Typography.Text>}
    <Flex vertical>
      <Typography.Text strong>{capitalize(t('climateChange.impactedHazards'))}</Typography.Text>
      {climateVariable.hazards.length ?
        <ul style={{margin: 0, paddingLeft: '1.2rem', color: token.colorText}}>
          {climateVariable.hazards.map(hazard => <li key={hazard.code}>
            <Typography.Text>
              {getHazardLabel(hazard.code)}{hazard.description ? `: ${hazard.description}` : ''}
            </Typography.Text>
          </li>)}
        </ul> :
        <Typography.Text type={'secondary'} italic>{capitalize(t('climateChange.noImpactedHazards'))}</Typography.Text>
      }
    </Flex>
  </Flex>

  return <HelpTooltip
    tooltip={{
      title,
      color: 'white',
      overlayStyle: {maxWidth: 360},
    }}
    iconStyle={iconStyle}
  />
}
